import LayoutLogin from '~componentes/LayoutLogin.vue';
import RecuperarSenhaPessoaFisica from './RecuperarSenhaPessoaFisica.vue';

export default {
  path: '/recuperar-senha-pessoa-fisica',
  component: LayoutLogin,
  children: [
    {
      path: '',
      component: RecuperarSenhaPessoaFisica,
      name: 'recuperarsenhapessoafisica',
    },
  ]
}





// WEBPACK FOOTER //
// ./FrontEnd/modulos/recuperar-senha-pessoa-fisica/rotas.js